module.exports = __webpack_public_path__ + "img/collection_place.25876ebe.png";